import React, { createContext, useState, useContext, useEffect } from 'react';
import API from './api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchProfile = async () => {
    try {
      const token = localStorage.getItem('access_token');
      if (!token) { setLoading(false); return; }
      const res = await API.get('/accounts/profile/');
      setUser(res.data);
    } catch {
      localStorage.clear();
      setUser(null);
    }
    setLoading(false);
  };

  useEffect(() => { fetchProfile(); }, []);

  const login = async (username, password, extra = {}) => {
    const res = await API.post('/accounts/login/', { username, password, ...extra });
    localStorage.setItem('access_token', res.data.access);
    localStorage.setItem('refresh_token', res.data.refresh);
    await fetchProfile();
    return res.data;
  };

  const register = async (data) => {
    const res = await API.post('/accounts/register/', data);
    return res.data;
  };

  const logout = () => {
    // Only remove auth-related keys — keep onboarding flag + UI prefs across logins
    try {
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
    } catch (e) {}
    setUser(null);
    window.location.href = '/';
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, fetchProfile }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
